import { ReactNode } from "react";
import { RiCloseCircleFill } from "@remixicon/react";

type WarningVariant = "warning" | "danger";

interface WarningBoxProps {
  variant: WarningVariant;
  title: string;
  items?: Array<{ icon?: ReactNode; text: ReactNode }>;
  footer?: ReactNode;
}

const variantStyles: Record<WarningVariant, string> = {
  warning:
    "bg-warning-50 border-error-100",
  danger:
    "bg-error-50 border-error-100",
};

export default function WarningBox({ variant, title, items, footer }: WarningBoxProps) {
  return (
    <div className={`border rounded p-4 ${variantStyles[variant]}`}>
      <p className={`text-base font-semibold text-neutral-700 leading-7 ${items?.length ? "mb-4" : ""}`}>
        {title}
      </p>
      <div className="space-y-3">
        {items?.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-sm text-neutral-700"
          >
            {item.icon || (
              <RiCloseCircleFill className="size-5 text-error-600 flex-shrink-0" />
            )}
            <span className="flex-1">{item.text}</span>
          </div>
        ))}
      </div>
      {footer && <div className="border-t border-neutral-200 mt-3 pt-3 font-semibold">{footer}</div>}
    </div>
  );
}
